module.exports = __webpack_public_path__ + "media/images/video-thumbnail-f5ebccd52900dee30b9f67ef4463dc42.jpg";